import { render, staticRenderFns } from "./DialogReportReasonsForChangedVisitTypes.vue?vue&type=template&id=1a77d6c4"
import script from "./DialogReportReasonsForChangedVisitTypes.vue?vue&type=script&lang=js"
export * from "./DialogReportReasonsForChangedVisitTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports